import script from "./SignatureInputComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureInputComponent.vue?vue&type=script&setup=true&lang=js"

import "./SignatureInputComponent.vue?vue&type=style&index=0&id=af36cf92&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af36cf92"]])

export default __exports__